// Sent by the purchase order's "Type de signature" input (once "Automatique"
// is consented and saved) to the "Contrat (PDF)" field, which then opens its
// launch recap modal -- see withContractSignatureMode and withPdfDropzone.
export const OPEN_CONTRACT_SIGNATURE_LAUNCH_EVENT =
  'contract-signature:open-launch';

// Sent by the same input whenever its choice changes, saved or not: the
// launch recap shows it and the launch applies it (the API's
// ContractsController#launch_signature)
export const CONTRACT_SIGNATURE_MODE_CHANGED_EVENT =
  'contract-signature:mode-changed';

export type OpenContractSignatureLaunchDetail = {
  contractId: string | number;
  signatureMode: string;
};
